import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const OrthodonticsIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
    />
    <g clipPath='url(#clip0_414_16444)'>
      <path
        d='M58.3333 20H44.1667C42.4271 20 40.8957 20.8888 40 22.2366C39.1043 20.8888 37.5729 20 35.8333 20H21.6667C17.9848 20 15 22.9848 15 26.6667V30C15 31.8409 16.4924 33.3333 18.3333 33.3333H61.6667C63.5076 33.3333 65 31.8409 65 30V26.6667C65 22.9848 62.0152 20 58.3333 20Z'
        fill='#F06E82'
      />
      <path
        d='M64.1667 27.5C63.7065 27.5 63.3333 27.1269 63.3333 26.6667C63.3333 23.9096 61.0904 21.6667 58.3333 21.6667H44.1667C43.0479 21.6667 42.0092 22.2245 41.3881 23.159L40.6941 24.2033C40.5396 24.4357 40.2791 24.5754 40 24.5754C39.7209 24.5754 39.4604 24.4357 39.3059 24.2033L38.6119 23.159C37.9908 22.2245 36.9521 21.6667 35.8333 21.6667H21.6667C18.9096 21.6667 16.6667 23.9096 16.6667 26.6667C16.6667 27.1269 16.2935 27.5 15.8333 27.5C15.3731 27.5 15 27.1269 15 26.6667C15 22.9906 17.9906 20 21.6667 20H35.8333C37.5116 20 39.0692 20.836 40 22.2366C40.9308 20.836 42.4884 20 44.1667 20H58.3333C62.0094 20 65 22.9906 65 26.6667C65 27.1269 64.6269 27.5 64.1667 27.5Z'
        fill='#F591AA'
      />
      <path
        d='M34.1668 23.3333C37.3885 23.3333 40.0002 25.9449 40.0002 29.1666V34.9999C40.0002 36.8409 38.5078 38.3333 36.6668 38.3333H31.6668C29.8259 38.3333 28.3335 36.8409 28.3335 34.9999V29.1666C28.3335 25.9449 30.9452 23.3333 34.1668 23.3333Z'
        fill='#D7E6F0'
      />
      <path
        d='M34.1667 23.3333C33.5873 23.3333 33.0282 23.419 32.5 23.5762C34.9093 24.2935 36.6667 26.5242 36.6667 29.1666V34.9999C36.6667 36.8409 35.1743 38.3333 33.3333 38.3333H36.6667C38.5076 38.3333 40 36.8409 40 34.9999V29.1666C40 25.9449 37.3883 23.3333 34.1667 23.3333Z'
        fill='#A5C3DC'
      />
      <path
        d='M45.8333 23.3333C49.055 23.3333 51.6667 25.9449 51.6667 29.1666V34.9999C51.6667 36.8409 50.1743 38.3333 48.3333 38.3333H43.3333C41.4924 38.3333 40 36.8409 40 34.9999V29.1666C40 25.9449 42.6117 23.3333 45.8333 23.3333Z'
        fill='#D7E6F0'
      />
      <path
        d='M45.8332 23.3333C45.2538 23.3333 44.6947 23.419 44.1665 23.5762C46.5758 24.2935 48.3332 26.5242 48.3332 29.1666V34.9999C48.3332 36.8409 46.8408 38.3333 44.9998 38.3333H48.3332C50.1741 38.3333 51.6665 36.8409 51.6665 34.9999V29.1666C51.6665 25.9449 49.0548 23.3333 45.8332 23.3333Z'
        fill='#A5C3DC'
      />
      <path
        d='M23.3335 25.5554C26.095 25.5554 28.3335 27.794 28.3335 30.5554V33.8888C28.3335 35.7297 26.8411 37.2221 25.0002 37.2221H21.6668C19.8259 37.2221 18.3335 35.7297 18.3335 33.8888V30.5554C18.3335 27.7941 20.572 25.5554 23.3335 25.5554Z'
        fill='#D7E6F0'
      />
      <path
        d='M23.3332 25.5554C22.7486 25.5554 22.188 25.6567 21.6665 25.841C23.6083 26.5276 24.9998 28.3785 24.9998 30.5554V33.8888C24.9998 35.7297 23.5074 37.2221 21.6665 37.2221H24.9998C26.8408 37.2221 28.3332 35.7297 28.3332 33.8888V30.5554C28.3332 27.7941 26.0946 25.5554 23.3332 25.5554Z'
        fill='#A5C3DC'
      />
      <path
        d='M56.6665 25.5554C59.428 25.5554 61.6665 27.794 61.6665 30.5554V33.8888C61.6665 35.7297 60.1741 37.2221 58.3332 37.2221H54.9998C53.1589 37.2221 51.6665 35.7297 51.6665 33.8888V30.5554C51.6665 27.7941 53.905 25.5554 56.6665 25.5554Z'
        fill='#D7E6F0'
      />
      <path
        d='M56.6667 25.5554C56.0821 25.5554 55.5215 25.6567 55 25.841C56.9418 26.5276 58.3333 28.3785 58.3333 30.5554V33.8888C58.3333 35.7297 56.8409 37.2221 55 37.2221H58.3333C60.1743 37.2221 61.6667 35.7297 61.6667 33.8888V30.5554C61.6667 27.7941 59.4281 25.5554 56.6667 25.5554Z'
        fill='#A5C3DC'
      />
      <path d='M15 30.8333H65V32.4999H15V30.8333Z' fill='#6987A0' />
      <path
        d='M36.6668 34.1667H31.6668C31.2066 34.1667 30.8335 33.7936 30.8335 33.3334V30.0001C30.8335 29.5399 31.2066 29.1667 31.6668 29.1667H36.6668C37.127 29.1667 37.5002 29.5399 37.5002 30.0001V33.3334C37.5002 33.7936 37.127 34.1667 36.6668 34.1667Z'
        fill='#A5C3DC'
      />
      <path d='M30.8335 30.8333H37.5002V32.4999H30.8335V30.8333Z' fill='#87A5BE' />
      <path
        d='M32.6388 33.3334C32.2553 33.3334 31.9443 33.0225 31.9443 32.639V30.6945C31.9443 30.3109 32.2553 30 32.6388 30C33.0224 30 33.3333 30.3109 33.3333 30.6945V32.639C33.3333 33.0225 33.0224 33.3334 32.6388 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M35.6945 33.3334C35.3109 33.3334 35 33.0225 35 32.639V30.6945C35 30.3109 35.3109 30 35.6945 30C36.078 30 36.389 30.3109 36.389 30.6945V32.639C36.3889 33.0225 36.078 33.3334 35.6945 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M48.3333 34.1667H43.3333C42.8731 34.1667 42.5 33.7936 42.5 33.3334V30.0001C42.5 29.5399 42.8731 29.1667 43.3333 29.1667H48.3333C48.7935 29.1667 49.1667 29.5399 49.1667 30.0001V33.3334C49.1667 33.7936 48.7935 34.1667 48.3333 34.1667Z'
        fill='#A5C3DC'
      />
      <path d='M42.5 30.8333H49.1667V32.4999H42.5V30.8333Z' fill='#87A5BE' />
      <path
        d='M44.3053 33.3334C43.9218 33.3334 43.6108 33.0225 43.6108 32.639V30.6945C43.6108 30.3109 43.9218 30 44.3053 30C44.6889 30 44.9998 30.3109 44.9998 30.6945V32.639C44.9998 33.0225 44.6889 33.3334 44.3053 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M47.361 33.3334C46.9774 33.3334 46.6665 33.0225 46.6665 32.639V30.6945C46.6665 30.3109 46.9774 30 47.361 30C47.7445 30 48.0555 30.3109 48.0555 30.6945V32.639C48.0554 33.0225 47.7445 33.3334 47.361 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M59.1668 34.1667H54.1668C53.7066 34.1667 53.3335 33.7936 53.3335 33.3334V30.0001C53.3335 29.5399 53.7066 29.1667 54.1668 29.1667H59.1668C59.627 29.1667 60.0002 29.5399 60.0002 30.0001V33.3334C60.0002 33.7936 59.627 34.1667 59.1668 34.1667Z'
        fill='#A5C3DC'
      />
      <path d='M53.3335 30.8333H60.0002V32.4999H53.3335V30.8333Z' fill='#87A5BE' />
      <path
        d='M55.1388 33.3334C54.7553 33.3334 54.4443 33.0225 54.4443 32.639V30.6945C54.4443 30.3109 54.7553 30 55.1388 30C55.5224 30 55.8333 30.3109 55.8333 30.6945V32.639C55.8333 33.0225 55.5224 33.3334 55.1388 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M58.1945 33.3334C57.8109 33.3334 57.5 33.0225 57.5 32.639V30.6945C57.5 30.3109 57.8109 30 58.1945 30C58.578 30 58.889 30.3109 58.889 30.6945V32.639C58.8889 33.0225 58.578 33.3334 58.1945 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M25.8333 34.1667H20.8333C20.3731 34.1667 20 33.7936 20 33.3334V30.0001C20 29.5399 20.3731 29.1667 20.8333 29.1667H25.8333C26.2935 29.1667 26.6667 29.5399 26.6667 30.0001V33.3334C26.6667 33.7936 26.2935 34.1667 25.8333 34.1667Z'
        fill='#A5C3DC'
      />
      <path d='M20 30.8333H26.6667V32.4999H20V30.8333Z' fill='#87A5BE' />
      <path
        d='M21.8053 33.3334C21.4218 33.3334 21.1108 33.0225 21.1108 32.639V30.6945C21.1108 30.3109 21.4218 30 21.8053 30C22.1889 30 22.4998 30.3109 22.4998 30.6945V32.639C22.4998 33.0225 22.1889 33.3334 21.8053 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M24.861 33.3334C24.4774 33.3334 24.1665 33.0225 24.1665 32.639V30.6945C24.1665 30.3109 24.4774 30 24.861 30C25.2445 30 25.5555 30.3109 25.5555 30.6945V32.639C25.5554 33.0225 25.2445 33.3334 24.861 33.3334Z'
        fill='#D7E6F0'
      />
      <path
        d='M58.3333 60.0001H44.1667C42.4271 60.0001 40.8957 59.1113 40 57.7635C39.1043 59.1113 37.5729 60.0001 35.8333 60.0001H21.6667C17.9848 60.0001 15 57.0153 15 53.3334V50.0001C15 48.1591 16.4924 46.6667 18.3333 46.6667H61.6667C63.5076 46.6667 65 48.1591 65 50.0001V53.3334C65 57.0153 62.0152 60.0001 58.3333 60.0001Z'
        fill='#F06E82'
      />
      <path
        d='M58.3333 60H44.1667C42.4884 60 40.9308 59.164 40 57.7634C39.0692 59.164 37.5116 60 35.8333 60H21.6667C17.9906 60 15 57.0094 15 53.3333C15 52.8731 15.3731 52.5 15.8333 52.5C16.2935 52.5 16.6667 52.8731 16.6667 53.3333C16.6667 56.0904 18.9096 58.3333 21.6667 58.3333H35.8333C36.9521 58.3333 37.9908 57.7755 38.6119 56.841L39.3059 55.7967C39.4604 55.5643 39.7209 55.4246 40 55.4246C40.2791 55.4246 40.5396 55.5643 40.6941 55.7967L41.3881 56.841C42.0092 57.7755 43.0479 58.3333 44.1667 58.3333H58.3333C61.0904 58.3333 63.3333 56.0904 63.3333 53.3333C63.3333 52.8731 63.7065 52.5 64.1667 52.5C64.6269 52.5 65 52.8731 65 53.3333C65 57.0094 62.0094 60 58.3333 60Z'
        fill='#F591AA'
      />
      <path
        d='M25 54.4445C27.7615 54.4445 30 52.206 30 49.4445V46.1112C30 44.2702 28.5076 42.7778 26.6667 42.7778H23.3333C21.4924 42.7778 20 44.2702 20 46.1112V49.4445C20 52.2059 22.2385 54.4445 25 54.4445Z'
        fill='#D7E6F0'
      />
      <path
        d='M25.0002 54.4445C24.4156 54.4445 23.855 54.3432 23.3335 54.1589C25.2753 53.4723 26.6668 51.6214 26.6668 49.4445V46.1112C26.6668 44.2702 25.1744 42.7778 23.3335 42.7778H26.6668C28.5078 42.7778 30.0002 44.2702 30.0002 46.1112V49.4445C30.0002 52.2059 27.7616 54.4445 25.0002 54.4445Z'
        fill='#A5C3DC'
      />
      <path
        d='M35 54.4445C37.7615 54.4445 40 52.206 40 49.4445V46.1112C40 44.2702 38.5076 42.7778 36.6667 42.7778H33.3333C31.4924 42.7778 30 44.2702 30 46.1112V49.4445C30 52.2059 32.2385 54.4445 35 54.4445Z'
        fill='#D7E6F0'
      />
      <path
        d='M35.0002 54.4445C34.4156 54.4445 33.855 54.3432 33.3335 54.1589C35.2753 53.4723 36.6668 51.6214 36.6668 49.4445V46.1112C36.6668 44.2702 35.1744 42.7778 33.3335 42.7778H36.6668C38.5078 42.7778 40.0002 44.2702 40.0002 46.1112V49.4445C40.0002 52.2059 37.7616 54.4445 35.0002 54.4445Z'
        fill='#A5C3DC'
      />
      <path
        d='M45 54.4445C47.7615 54.4445 50 52.206 50 49.4445V46.1112C50 44.2702 48.5076 42.7778 46.6667 42.7778H43.3333C41.4924 42.7778 40 44.2702 40 46.1112V49.4445C40 52.2059 42.2385 54.4445 45 54.4445Z'
        fill='#D7E6F0'
      />
      <path
        d='M45.0002 54.4445C44.4156 54.4445 43.855 54.3432 43.3335 54.1589C45.2753 53.4723 46.6668 51.6214 46.6668 49.4445V46.1112C46.6668 44.2702 45.1744 42.7778 43.3335 42.7778H46.6668C48.5078 42.7778 50.0002 44.2702 50.0002 46.1112V49.4445C50.0002 52.2059 47.7616 54.4445 45.0002 54.4445Z'
        fill='#A5C3DC'
      />
      <path
        d='M55 54.4445C57.7615 54.4445 60 52.206 60 49.4445V46.1112C60 44.2702 58.5076 42.7778 56.6667 42.7778H53.3333C51.4924 42.7778 50 44.2702 50 46.1112V49.4445C50 52.2059 52.2385 54.4445 55 54.4445Z'
        fill='#D7E6F0'
      />
      <path
        d='M55.0002 54.4445C54.4156 54.4445 53.855 54.3432 53.3335 54.1589C55.2753 53.4723 56.6668 51.6214 56.6668 49.4445V46.1112C56.6668 44.2702 55.1744 42.7778 53.3335 42.7778H56.6668C58.5078 42.7778 60.0002 44.2702 60.0002 46.1112V49.4445C60.0002 52.2059 57.7616 54.4445 55.0002 54.4445Z'
        fill='#A5C3DC'
      />
      <path d='M15 47.5H65V49.1667H15V47.5Z' fill='#6987A0' />
      <path
        d='M37.4998 45.8333H32.4998C32.0396 45.8333 31.6665 46.2064 31.6665 46.6666V49.9999C31.6665 50.4601 32.0396 50.8333 32.4998 50.8333H37.4998C37.96 50.8333 38.3332 50.4601 38.3332 49.9999V46.6666C38.3332 46.2064 37.96 45.8333 37.4998 45.8333Z'
        fill='#A5C3DC'
      />
      <path d='M31.6665 47.5H38.3332V49.1667H31.6665V47.5Z' fill='#87A5BE' />
      <path
        d='M33.4723 46.6667C33.0888 46.6667 32.7778 46.9777 32.7778 47.3612V49.3057C32.7778 49.6892 33.0888 50.0002 33.4723 50.0002C33.8559 50.0002 34.1668 49.6892 34.1668 49.3057V47.3612C34.1668 46.9777 33.8559 46.6667 33.4723 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M36.528 46.6667C36.1444 46.6667 35.8335 46.9777 35.8335 47.3612V49.3057C35.8335 49.6892 36.1444 50.0002 36.528 50.0002C36.9115 50.0002 37.2225 49.6892 37.2225 49.3057V47.3612C37.2224 46.9777 36.9115 46.6667 36.528 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M47.4998 45.8333H42.4998C42.0396 45.8333 41.6665 46.2064 41.6665 46.6666V49.9999C41.6665 50.4601 42.0396 50.8333 42.4998 50.8333H47.4998C47.96 50.8333 48.3332 50.4601 48.3332 49.9999V46.6666C48.3332 46.2064 47.96 45.8333 47.4998 45.8333Z'
        fill='#A5C3DC'
      />
      <path d='M41.6665 47.5H48.3332V49.1667H41.6665V47.5Z' fill='#87A5BE' />
      <path
        d='M43.4723 46.6667C43.0888 46.6667 42.7778 46.9777 42.7778 47.3612V49.3057C42.7778 49.6892 43.0888 50.0002 43.4723 50.0002C43.8559 50.0002 44.1668 49.6892 44.1668 49.3057V47.3612C44.1668 46.9777 43.8559 46.6667 43.4723 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M46.528 46.6667C46.1444 46.6667 45.8335 46.9777 45.8335 47.3612V49.3057C45.8335 49.6892 46.1444 50.0002 46.528 50.0002C46.9115 50.0002 47.2225 49.6892 47.2225 49.3057V47.3612C47.2224 46.9777 46.9115 46.6667 46.528 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M57.4998 45.8333H52.4998C52.0396 45.8333 51.6665 46.2064 51.6665 46.6666V49.9999C51.6665 50.4601 52.0396 50.8333 52.4998 50.8333H57.4998C57.96 50.8333 58.3332 50.4601 58.3332 49.9999V46.6666C58.3332 46.2064 57.96 45.8333 57.4998 45.8333Z'
        fill='#A5C3DC'
      />
      <path d='M51.6665 47.5H58.3332V49.1667H51.6665V47.5Z' fill='#87A5BE' />
      <path
        d='M53.4723 46.6667C53.0888 46.6667 52.7778 46.9777 52.7778 47.3612V49.3057C52.7778 49.6892 53.0888 50.0002 53.4723 50.0002C53.8559 50.0002 54.1668 49.6892 54.1668 49.3057V47.3612C54.1668 46.9777 53.8559 46.6667 53.4723 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M56.528 46.6667C56.1444 46.6667 55.8335 46.9777 55.8335 47.3612V49.3057C55.8335 49.6892 56.1444 50.0002 56.528 50.0002C56.9115 50.0002 57.2225 49.6892 57.2225 49.3057V47.3612C57.2224 46.9777 56.9115 46.6667 56.528 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M27.4998 45.8333H22.4998C22.0396 45.8333 21.6665 46.2064 21.6665 46.6666V49.9999C21.6665 50.4601 22.0396 50.8333 22.4998 50.8333H27.4998C27.96 50.8333 28.3332 50.4601 28.3332 49.9999V46.6666C28.3332 46.2064 27.96 45.8333 27.4998 45.8333Z'
        fill='#A5C3DC'
      />
      <path d='M21.6665 47.5H28.3332V49.1667H21.6665V47.5Z' fill='#87A5BE' />
      <path
        d='M23.4723 46.6667C23.0888 46.6667 22.7778 46.9777 22.7778 47.3612V49.3057C22.7778 49.6892 23.0888 50.0002 23.4723 50.0002C23.8559 50.0002 24.1668 49.6892 24.1668 49.3057V47.3612C24.1668 46.9777 23.8559 46.6667 23.4723 46.6667Z'
        fill='#D7E6F0'
      />
      <path
        d='M26.528 46.6667C26.1444 46.6667 25.8335 46.9777 25.8335 47.3612V49.3057C25.8335 49.6892 26.1444 50.0002 26.528 50.0002C26.9115 50.0002 27.2225 49.6892 27.2225 49.3057V47.3612C27.2224 46.9777 26.9115 46.6667 26.528 46.6667Z'
        fill='#D7E6F0'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_16444'>
        <rect width='50' height='50' fill='white' transform='translate(15.4282 15)' />
      </clipPath>
    </defs>
  </svg>
));
OrthodonticsIcon.displayName = 'OrthodonticsIcon';

export default OrthodonticsIcon;
